import React from 'react';
import { BilledByPartner } from './billedByPartner';
import { BilledByPlatform } from './billedByPlatform';


export const Step4 = ({user, isLoading, referent}) => {
    if(user.billedByPartner){
        return <BilledByPartner userId={user.id} isLoading={isLoading} referent={referent}/>
    }else{
        return <BilledByPlatform user={user} isLoading={isLoading} referent={referent} />
    }
}